const { upgradeArray } = require('../utils')

const USERS_REQUISITE_TYPES = upgradeArray([ 'business', 'person' ])
const USERS_REQUISITE_BUSINESS_TYPES = upgradeArray([ 'organization', 'individual' ])

const PUBLIC_FIELDS_USER = [ 'id', 'username', 'data.firstName', 'data.lastName', '$verified' ]

module.exports = {
  PUBLIC_FIELDS_USER,
  USERS_REQUISITE_TYPES,
  USERS_REQUISITE_BUSINESS_TYPES
}
